import { Flex, TextInput, PrimaryButton } from "@base-ui";
import { closePopup } from "utils/events";
import { debounce } from "utils/debounce";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmbedVideo(props) {
  var setActiveVideo = props.setActiveVideo,
    activeVideo = props.activeVideo,
    selectVideo = props.selectVideo,
    description = props.description,
    setDescription = props.setDescription;
  var debouncedTextUpdate = debounce(setDescription, [500]);
  var disableUpload = !((activeVideo === null || activeVideo === void 0 ? void 0 : activeVideo.length) > 10 && (description === null || description === void 0 ? void 0 : description.length) > 10);
  return /*#__PURE__*/_jsxs(Flex.Column, {
    m: "10px 0",
    height: "350px",
    children: [/*#__PURE__*/_jsx(TextInput, {
      id: "add-video-description-".concat(activeVideo),
      value: description,
      placeholder: "Beskriv videon...",
      label: "Fyll i en videobeskrivning f\xF6r synskadade",
      onChange: debouncedTextUpdate,
      border: "primary"
    }), /*#__PURE__*/_jsx("div", {
      style: {
        margin: "10px 0"
      }
    }), /*#__PURE__*/_jsx(TextInput, {
      id: "add-video-src-".concat(activeVideo),
      value: activeVideo,
      placeholder: "Fyll i en l\xE4nk till din video...",
      label: "Fyll i en l\xE4nk till din video",
      onChange: setActiveVideo,
      border: "primary"
    }), /*#__PURE__*/_jsxs(Flex.Row, {
      justifyContent: "flex-end",
      m: "auto 0 0",
      children: [/*#__PURE__*/_jsx(PrimaryButton, {
        id: "cancel-upload-video",
        onClick: closePopup,
        mr: "10px",
        width: "130px",
        children: "Avbryt"
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        id: "upload-video",
        title: disableUpload ? "Du behöver välja en video och fylla i en beskrivning" : undefined,
        width: "160px",
        disabled: disableUpload,
        onClick: function onClick() {
          return selectVideo({
            src: activeVideo,
            alt: description
          });
        },
        children: "V\xE4lj video"
      })]
    })]
  });
}